// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import './Circle.module.scss';
// =========================

export default function Circle({
    children,
    background = 'white',
    onClick,
    inactive,
}: {
    children: React.ReactNode;
    background?: string;
    onClick?: () => void;
    inactive?: boolean;
}) {
    return (
        <motion.div
            styleName="circle"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={onClick}
            style={{
                background,
                color: background !== 'white' ? 'white' : 'black',
                opacity: inactive ? 0.5 : 1,
                pointerEvents: inactive ? 'none' : 'all',
            }}
        >
            {children}
        </motion.div>
    );
}
